import { Injectable, EventEmitter, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SessionService } from './../../../services/session.service';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from '../../../tech-lib-portal.interceptor';
import { DocManagerEnum } from '../../../services/api-names';
import { DocumentDataInterface } from '../request/interfaces/document-data.interface';
import { DocumentRefDataInterface } from '../request/interfaces/document-ref-data.interface';
import { Utils } from '../../../utils/utils';
import { SheduledReportsGenerateInterface } from '../response/interfaces/scheduledreportsgenerated.interface';
import { MassiveReportInterface } from '../response/interfaces/massivereport.interface';
import { SheduledReportsInterface } from '../response/interfaces/sheduled-reports.interface';
import { SignedDocumentsTmpInterface } from '../response/interfaces/signeddocumentstmp.interface';
import { AccountStatementDocumentsResultInterface } from '../response/interfaces/accountstatementdocuments.interface';
/*
import { saveAs } from 'file-saver';
*/

@Injectable({
  providedIn: 'root',
})
export class DocmanagerService {
  private idClient: string;
  public refData: any;
  public documentRefdata$ = new EventEmitter<any>();
  HttpHeaders: HttpHeaders;

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private http: HttpClient
  ) {}

  public getAccountStatementsDocument(): Observable<
    [SignedDocumentsTmpInterface]
  > {
    let url =
      this.config.baseApi + DocManagerEnum.get_accountstatementsdocument;
    return this.http.get<[SignedDocumentsTmpInterface]>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
  public getDocuments(): Observable<[DocumentDataInterface]> {
    var url = this.config.baseApi + DocManagerEnum.get_manualdocuments;
    return this.http.get<[DocumentDataInterface]>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getDocumentRefdata(): Observable<DocumentRefDataInterface> {
    var url = this.config.baseApi + DocManagerEnum.get_manualdocument_refdata;
    return this.http.get<DocumentRefDataInterface>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getDocumentFile(id: string): Observable<any> {
    let url = Utils.formatString(
      this.config.baseApi + DocManagerEnum.get_manualdocumentfile,
      [id]
    );
    return this.http
      .get<any>(url, {
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public getSheduleReports(): Observable<SheduledReportsInterface[]> {
    var url = this.config.baseApi + DocManagerEnum.get_sheduledreports;
    return this.http.get<SheduledReportsInterface[]>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getMassiveReport(): Observable<MassiveReportInterface> {
    var url = this.config.baseApi + DocManagerEnum.get_massivereport;
    return this.http.get<MassiveReportInterface>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getSignedDocuments(): Observable<SignedDocumentsTmpInterface[]> {
    var url = this.config.baseApi + DocManagerEnum.get_signeddocuments;
    return this.http.get<SignedDocumentsTmpInterface[]>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  /* Descarga Documentos */
  public getDocument1(documentId: string): Observable<any> {
    const url =
      this.config.baseApi +
      Utils.formatString(DocManagerEnum.get_document1, [documentId]);

    return this.http
      .get<any>(url, {
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public getDocument2(
    portfolioCode: string,
    documentId: string
  ): Observable<any> {
    const url =
      this.config.baseApi +
      Utils.formatString(DocManagerEnum.get_document2, [
        portfolioCode,
        documentId,
      ]);

    return this.http
      .get<any>(url, {
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public getDocumentSheduleReport(shedulereportId: string): Observable<any> {
    const url =
      this.config.baseApi +
      Utils.formatString(DocManagerEnum.get_documentshedulereport, [
        shedulereportId,
      ]);

    return this.http
      .get<any>(url, {
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public getDocumentMassiveReport(massivereportId: string): Observable<any> {
    const url =
      this.config.baseApi +
      Utils.formatString(DocManagerEnum.get_documentmassivereport, [
        massivereportId,
      ]);

    return this.http
      .get<any>(url, {
        observe: 'response',
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
  }

  public getOthersDocuments(): Observable<SignedDocumentsTmpInterface[]> {
    var url = this.config.baseApi + DocManagerEnum.get_othersdocuments;
    return this.http.get<SignedDocumentsTmpInterface[]>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getAccountStatementDocuments(
    portfolioCode: string
  ): Observable<any> {
    var url = Utils.formatString(
      this.config.baseApi + DocManagerEnum.get_accountstatementdocuments,
      [portfolioCode]
    );
    return this.http.get<any>(url).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
